import { rem } from 'polished'
import React, { useContext } from 'react'
import styled from 'styled-components'

import Image from 'components/Common/Image'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import ContactContext from 'contexts/contactContext'
import { NO_24_7_SUPPORT_REGIONS } from 'constants/config/region'
import GeoContext from 'contexts/geoContext'
import { getCustomerSupportAgentImage } from './CustomerSupport/getAgentImage'

const IMAGE_WIDTH = 100

const Container = styled.div`
  display: grid;
  grid-template-columns: ${rem(IMAGE_WIDTH)} 1fr;
  align-items: center;
  gap: ${rem(16)};
`

interface Props {
  heading?: string;
  description?: string;
}

function CustomerSupportBlock(props: Props) {
  const { currentRegionCode } = useContext(GeoContext)

  const customerSupportImage = getCustomerSupportAgentImage('left', false, currentRegionCode)
  const {
    heading = `Our team are available ${NO_24_7_SUPPORT_REGIONS.includes(currentRegionCode) ? '7 days a week from 9am to 7pm' : '24 hours, 7 days'}`,
    description = 'Need help? Call our dedicated customer service team anytime.',
  } = props

  const supportPhone = useContext(ContactContext)

  return (
    <Container>
      <Image
        alt="Travel companion on your trip"
        id={customerSupportImage}
        width={IMAGE_WIDTH}
      />
      <Group direction="vertical" gap={8}>
        <Heading variant="heading6">
          {heading}
        </Heading>
        <BodyText variant="medium">
          {description}
        </BodyText>
        <TextLink startIcon={<LinePhoneIcon />} href={`tel:${supportPhone.local.number}`}>
          {supportPhone.local.humanReadable}
        </TextLink>
      </Group>
    </Container>
  )
}

export default CustomerSupportBlock
